// extracted by mini-css-extract-plugin
export var centerText = "_it-8";
export var container = "_it-0";
export var doughnutContainer = "_it-7";
export var legend = "_it-a";
export var legendItemColorDisplay = "_it-b";
export var legendItemLabel = "_it-d";
export var legendItemValue = "_it-c";
export var lg = "_it-5";
export var maxWidth = "_it-9";
export var md = "_it-4";
export var responsive = "_it-6";
export var sm = "_it-3";
export var xs = "_it-2";
export var xxs = "_it-1";